/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React, { useState } from 'react';

// import PropTypes from 'prop-types';

import { Select, Form, Input, Radio, DatePicker, Card, Button } from 'antd';
import moment from 'moment';
import NumberFormat from 'react-number-format';

// import {
//   DownloadOutlined,
//   RightOutlined,
//   LeftOutlined,
// } from '@ant-design/icons';
// import { Document, Outline, Page } from 'react-pdf';
import fiftyStates from '../../../config/fiftyStates_copy.json';
import providence from '../../../config/candianProvinces.json';
import discountCodes from '../optionsJson/discountCodes.json';
import { childCode } from '../optionsJson/contract';

const { Option } = Select;
const { TextArea } = Input;

const Header = block => {
  const { data } = block;

  const createOptions = obj => {
    const keys = Object.keys(obj);

    const options = keys.map(key => ({ text: obj[key], value: key }));

    return options.map(option => (
      <Option value={option.value} key={option.value}>
        {option.text}
      </Option>
    ));
  };

  const [stateOptions] = useState(createOptions(fiftyStates));
  const [providenceOptions] = useState(createOptions(providence));
  const [discountOptions] = useState(createOptions(discountCodes));

  const disabledDate = current => current && current < moment().endOf('day');

  return (
    <div className="subcomponent-wrapper">
      <div className="subcomponent-header">CONTRACT</div>
      <div className="subcomponent-columns">
        <div style={{ width: '30vw' }}>
          <Form.Item
            required
            label={<p style={{ fontWeight: 800, margin: 0 }}>Bid Type</p>}
          >
            <Select
              allowClear
              value={data.values.bidTypeCd}
              onChange={value => {
                data.changeValues('bidTypeCd', value);
              }}
            >
              <Option value="BI">Bid without Exception</Option>
              <Option value="BW">Bid With Exception</Option>
              <Option value="AB">Alternate Bid</Option>
              <Option value="DQ ">No Bid </Option>
            </Select>
          </Form.Item>
          <br />
          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>
                {' '}
                Prompt Payment Discount Terms:
              </p>
            }
            required
            tooltip="This is a required field"
          >
            <Select
              allowClear
              value={data.values.prmptPayDscnt}
              onChange={value => {
                data.changeValues('prmptPayDscnt', value);
              }}
            >
              {discountOptions}
            </Select>
          </Form.Item>
        </div>
        <div style={{ width: '30vw' }}>
          <Form.Item
            label={<p style={{ fontWeight: 800, margin: 0 }}>Vendor Quote #</p>}
          >
            <Input
              value={data.values.vendQuoteNum}
              onChange={e => {
                data.changeValues('vendQuoteNum', e.target.value);
              }}
            />
          </Form.Item>
          <br />
          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>Quote Valid for</p>
            }
            required
            tooltip="This is a required field"
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <NumberFormat
                className="nf-rff-input-field__input form-control"
                style={{ width: '100px' }}
                value={data.values.daysValid}
                onChange={e => {
                  data.changeValues('daysValid', e.target.value);
                }}
              />{' '}
              <p style={{ fontWeight: 800, margin: 0 }}> Days</p>
            </div>
          </Form.Item>
        </div>
      </div>
      <div>
        <Form layout="vertical">
          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>
                Meets Packing Requirements?
              </p>
            }
          >
            <Radio.Group
              value={data.values.acceptPkg}
              onChange={e => {
                data.changeValues('acceptPkg', e.target.value);
              }}
            >
              <Radio value="N">No</Radio>
              <Radio value="Y">Yes</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </div>
      <div>
        <Form layout="vertical">
          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>
                Federal Supply Schedule (FSS) / Basic Ordering Amount (BOA) /
                Blanket Purchase Agreement (BPA)
              </p>
            }
          >
            <Radio.Group
              value={data.values.boaFssBpa}
              onChange={e => {
                data.changeValues('boaFssBpa', e.target.value);
              }}
            >
              <Radio value="NAP">N/A</Radio>
              <Radio value="FSS">FSS</Radio>
              <Radio value="BOA">BOA</Radio>
              <Radio value="BPA">BPA</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
        {data.values.boaFssBpa !== 'NAP' && (
          <div className="subcomponent-conditional">
            <Form layout="vertical">
              <Form.Item
                label={
                  <p style={{ fontWeight: 800, margin: 0 }}>
                    FSS/BOA/BPA Response:
                  </p>
                }
              >
                <div
                  style={{
                    display: 'flex',
                    width: '80%',
                    alignItems: 'center',
                    justifyContent: 'space-evenly',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                    }}
                  >
                    {' '}
                    <div
                      style={{
                        width: '50%',
                      }}
                    >
                      Contract #:
                    </div>
                    <Input
                      value={data.quoteValues.boaFssBpaNum}
                      onChange={e => {
                        data.changeQuoteValues('boaFssBpaNum', e.target.value);
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <div
                      style={{
                        width: '50%',
                      }}
                    >
                      Expiration Date:
                    </div>
                    <DatePicker
                      disabledDate={disabledDate}
                      value={
                        data.quoteValues.boaFssBpaExp
                          ? moment(data.quoteValues.boaFssBpaExp)
                          : null
                      }
                      onChange={(date, dateString) => {
                        data.changeQuoteValues('boaFssBpaExp', dateString);
                      }}
                    />
                  </div>
                </div>
              </Form.Item>
            </Form>
          </div>
        )}
      </div>
      <div>
        <div>
          <Form layout="vertical">
            <Form.Item
              label={
                <p style={{ fontWeight: 800, margin: 0 }}>
                  Child Labor Certification Code{' '}
                </p>
              }
            >
              <Select
                value={data.values.chldLbrCertCd}
                onChange={value => {
                  data.changeValues('chldLbrCertCd', value);
                }}
              >
                {createOptions(childCode)}
              </Select>
            </Form.Item>
          </Form>
        </div>
      </div>
      <div>
        <Form layout="vertical">
          <Form.Item
            label={<p style={{ fontWeight: 800, margin: 0 }}>Fob Point</p>}
          >
            <Radio.Group
              value={data.values.fobPoint}
              onChange={e => {
                data.changeValues('fobPoint', e.target.value);
              }}
            >
              <Radio value="D">Destination</Radio>
              <Radio value="O">Origin</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </div>
      {data.values.fobPoint === 'O' && (
        <div className="subcomponent-conditional">
          {' '}
          <Form layout="vertical">
            <Form.Item
              label={
                <p style={{ fontWeight: 800, margin: 0 }}>Origin Response</p>
              }
            >
              <div
                style={{
                  display: 'flex',
                  width: '80%',
                  alignItems: 'center',
                }}
              >
                <div style={{ marginLeft: '16px', marginRight: '8px' }}>
                  Country:
                </div>
                <Select
                  allowClear
                  value={data.values.fobCntry}
                  onChange={value => {
                    data.changeValues('fobCntry', value);
                  }}
                >
                  <Option value="US">United States of America</Option>
                  <Option value="CA">Canada</Option>
                </Select>
                <div style={{ marginLeft: '16px', marginRight: '8px' }}>
                  City:
                </div>
                <Input
                  value={data.values.fobCity}
                  onChange={e => {
                    data.changeValues('fobCity', e.target.value);
                  }}
                />
                {data.values.fobCntry === 'US' && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ marginLeft: '16px', marginRight: '8px' }}>
                      State:
                    </div>
                    <Select
                      allowClear
                      value={data.values.fobStProv}
                      onChange={value => {
                        data.changeValues('fobStProv', value);
                      }}
                      style={{ width: '200px' }}
                    >
                      {stateOptions}
                    </Select>
                  </div>
                )}

                {data.values.fobCntry === 'CA' && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ marginLeft: '16px', marginRight: '8px' }}>
                      Providence:
                    </div>
                    <Select
                      allowClear
                      value={data.values.fobStProv}
                      onChange={value => {
                        data.changeValues('fobStProv', value);
                      }}
                      style={{ width: '200px' }}
                    >
                      {providenceOptions}
                    </Select>
                  </div>
                )}
              </div>
            </Form.Item>
          </Form>
        </div>
      )}

      <div>
        <Form layout="vertical">
          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>
                Government Inspection Point
              </p>
            }
          >
            <Radio.Group
              value={data.values.insptnPointCd}
              onChange={e => {
                data.changeValues('insptnPointCd', e.target.value);
              }}
            >
              <Radio value="D">Destination</Radio>
              <Radio value="O">Origin</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </div>
      {data.values.insptnPointCd === 'O' && (
        <div className="subcomponent-conditional">
          {' '}
          <Form layout="vertical">
            <Form.Item
              label={
                <p style={{ fontWeight: 800, margin: 0 }}>
                  Place of Government Inspection{' '}
                </p>
              }
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    marginLeft: '16px',
                    marginRight: '8px',
                    width: '200px',
                  }}
                >
                  Packaging CAGE code
                </div>
                <Input
                  style={{ maxWidth: '300px' }}
                  value={data.quoteValues.plcGovPkgInsptnCage}
                  maxLength="5"
                  onChange={e => {
                    data.changeQuoteValues(
                      'plcGovPkgInsptnCage',
                      e.target.value,
                    );
                  }}
                />

                <div
                  style={{
                    marginLeft: '16px',
                    marginRight: '8px',
                    width: '200px',
                  }}
                >
                  Supplies CAGE code
                </div>
                <Input
                  style={{ maxWidth: '300px' }}
                  maxLength="5"
                  value={data.quoteValues.plcGovSupInsptnCage}
                  onChange={e => {
                    data.changeQuoteValues(
                      'plcGovSupInsptnCage',
                      e.target.value,
                    );
                  }}
                />
              </div>
            </Form.Item>
          </Form>
        </div>
      )}

      <div>
        <Form layout="vertical">
          <Form.Item
            label={
              <p style={{ fontWeight: 800, margin: 0 }}>SPI Process Proposed</p>
            }
          >
            Are you Proposing to use a Previously accepted SPI process?{' '}
            <Radio.Group
              value={data.quoteValues.subSpiProcPropsd}
              onChange={e => {
                data.changeQuoteValues('subSpiProcPropsd', e.target.value);
              }}
            >
              <Radio value="N">No</Radio>
              <Radio value="Y">Yes</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
        {data.values.subSpiProcPropsd === 'Y' && (
          <div className="subcomponent-conditional">
            {' '}
            <Form layout="vertical">
              <Form.Item>
                <div className="subcomponent-form-wrapper">
                  <div style={{ marginRight: '8px' }}>SPI Process:</div>
                  <Input
                    style={{ maxWidth: '300px' }}
                    value={data.quoteValues.spiProc}
                    onChange={e => {
                      data.changeQuoteValues('spiProc', e.target.value);
                    }}
                  />
                  <div style={{ marginLeft: '16px', marginRight: '8px' }}>
                    Facility:
                  </div>
                  <Input
                    style={{ maxWidth: '300px' }}
                    value={data.quoteValues.spiFacility}
                    onChange={e => {
                      data.changeQuoteValues('spiFacility', e.target.value);
                    }}
                  />
                </div>
                <div className="subcomponent-form-wrapper">
                  <div style={{ marginLeft: '16px', marginRight: '8px' }}>
                    Miltary or Federal Specification:
                  </div>
                  <Input
                    style={{ maxWidth: '300px' }}
                    value={data.quoteValues.spiMilSpec}
                    onChange={e => {
                      data.changeQuoteValues('spiMilSpec', e.target.value);
                    }}
                  />
                </div>

                <div className="subcomponent-form-wrapper">
                  <div style={{ marginLeft: '16px', marginRight: '8px' }}>
                    Contract Line Items, Subline Items, Component, or element
                    affected:
                  </div>
                  <Input
                    style={{ maxWidth: '300px' }}
                    value={data.quoteValues.spiAffectedClin}
                    onChange={e => {
                      data.changeQuoteValues('spiAffectedClin', e.target.value);
                    }}
                  />
                </div>
              </Form.Item>
            </Form>
          </div>
        )}
      </div>
      <div>
        <Form.Item style={{ marginTop: '16px' }}>
          <Card>
            <p style={{ fontWeight: 800, margin: 0 }}>Quote Remarks</p>
            <TextArea
              rows={6}
              onChange={e =>
                data.changeQuoteValues('quoteRemarks', e.target.value)
              }
              maxLength="255"
            />
          </Card>
        </Form.Item>
      </div>
      <div className="wizard-button-wrapper">
        <Button>Previous</Button>
        <Button
          onClick={() => {
            data.changeMenus('pricing');
          }}
          type="primary"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/subcomponents/DibbsContract.jsx